(function() {
  function onReady(selector, fn) {
    const el = document.querySelector(selector);
    if (el) return fn(el);
    new MutationObserver((_, obs) => {
      const found = document.querySelector(selector);
      if (found) {
        obs.disconnect();
        fn(found);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  onReady('#tee-artwork-form', function(wrapper) {
    const availableBlock = wrapper.querySelector('.tee-block.tee-available-products');
    const variantsBlock  = wrapper.querySelector('.tee-block.tee-variants');
    const customizeBlock = wrapper.querySelector('.tee-customize-main-form');

    if (!availableBlock || !variantsBlock || !customizeBlock) return;

    wrapper.insertBefore(customizeBlock, availableBlock);
    wrapper.insertBefore(variantsBlock, availableBlock);

    wrapper.querySelectorAll('.tee-ap-thumbnail-name-wrapper').forEach(el => {
      const text = el.textContent.trim();
      if (text.startsWith("Product Name:")) {
        el.style.display = "none";
      }
    });
  });

  onReady('body', function() {
    document.querySelectorAll('.product-option').forEach(option => {
      const label = option.querySelector('dt');
      const value = option.querySelector('dd');

      if (
        label &&
        value &&
        label.textContent.trim() === 'Color:' &&
        value.textContent.trim().toLowerCase().startsWith('default')
      ) {
        option.style.display = 'none';
      }
    });
  });
})();
